<script>
import * as C from '@shared/constants'

export default {
    name: 'SubmissionStatus',
    render: () => null,
    props: {
        status: String,
        lastSubmissionDate: Date,
    },
    computed: {
        // toast types:
        // success = post approved
        // warning = post storeable but not approved
        // error = post denied
        result () {
            switch (this.status) {
                case C.STATUS_APPROVED:
                    return {
                        toastType: 'success',
                        path: 'yourPostSubmitted',
                        emote: '🎉'
                    }
                case C.STATUS_PENDING:
                case C.STATUS_PENDING_AUTOMOD:
                case C.STATUS_PENDING_OAUTH_TOKEN:
                    return {
                        toastType: 'warning',
                        path: 'yourPostPendingApproval',
                        emote: '⌛'
                    }
                case C.STATUS_PROFANITY_DENIED:
                    return {
                        toastType: 'error',
                        path: 'yourPostDenied',
                        emote: '🤬'
                    }
                case C.STATUS_CHAT_BANNED:
                    return {
                        toastType: 'error',
                        path: 'youAreChatBanned',
                        emote: '😱'
                    }
                case C.STATUS_CHAT_TIMED_OUT:
                    return {
                        toastType: 'error',
                        path: 'youAreChatTimedOut',
                        emote: '🤐'
                    }
                case C.STATUS_COOLDOWN_DENIED:
                    return {
                        toastType: 'error',
                        path: 'youCantPostYet',
                        emote: '⌛'
                    }
                case C.STATUS_LINK_DENIED:
                    return {
                        toastType: 'error',
                        path: 'linksDenied',
                        emote: '🔗'
                    }
                default:
                    return {
                        toastType: 'error',
                        path: 'genericErrMsg',
                        emote: '😅'
                    }
            }
        },
        watchProps: vm => vm.status + vm.lastSubmissionDate
    },
    watch: {
        watchProps () {
            this.$toast(this.toastComponent(), {
                icon: false,
                type: this.result.toastType,
                showCloseButtonOnHover: true,
            })
        }
    },
    methods: {
        toastComponent () {
            const { path, emote } = this.result
            const msg = this.$t(path)
            return (
                <div class="after-submit-toast">
                    { emote && <Emote emote={emote}/> }
                    <span>{ msg }</span>
                </div>
            )
        },
    }
}
</script>

<style lang="scss" scoped>
.after-submit-toast {
    display: flex;
    align-items: center;
    font-size: 0.8rem;
    span {
        flex: 1;
        text-align: center;
    }
}
</style>
